import axios from 'axios';

export default class PaymentGateway {
  async decline(orgDomain, orgId, customerId, paymentId) {
    return axios.delete(
      `${orgDomain}/api/v1/secure-data/cc/orgs/${orgId}/customers/${customerId}/secure-payment/${paymentId}`
    );
  }
}
